// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_g2JT7 {
 
  background: linear-gradient(180deg, var(--white-background) 21%, var(--f5-background) 100%);
}
.containerInner_vmXtV{
  display: flex !important;
  font-family: "Inter", sans-serif;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  gap: 2rem;
  width: 100%;
 
  margin-top: 80px;
  background-color: transparent;
}
.content_hRXhK {
  display: flex;
  width: 63%;
}

.form_dNAyi {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  input,
  textarea {
    width: 100%;
  }
}

.leftSection_DvE3T {
  width: 100%;
}

.title_aqF6L {
  font-size: clamp(35px, 5vw, 55px) !important; 
  font-weight: 400;
  color: #18181b;
  margin-bottom: 0.5rem;
}

.subtitle_JcRep {
  font-size: clamp(12px, 3vw, 22px) !important; 
  font-weight: 400;
  color: #676767;
  margin-bottom: 2rem;
}

.inputGroup_KkTOE {
  margin-bottom: 1rem;
  width: 100%;
  flex: 1 1;
}
.inputGroupContainer_niid7 {
  display: flex;
  width: 100%;
  gap: 30px;
}
@media (max-width: 468px) {
  .inputGroupContainer_niid7 {
    flex-direction: column;
    gap: 2px;
  }
}

label {
  display: block;
  font-size: 14px;
  color: #18181b;
  margin-bottom: 0.5rem;
}

.input_mAlnQ,
.textarea_BI7BM {
  width: 100%;
  min-width: 200px;
  outline: none;
  border: 1px solid var(--f4-background);
  border-radius: 8px;
  font-size: 14px;
  padding: 1rem;
  background-color: var(--f4-background);
  color: var(--_71717a-color);
  box-sizing: border-box;
  &:focus {
    border: 2px solid #dadbdd;
  }
}

.input_mAlnQ {
  height: fit-content;
}

.textarea_BI7BM {
  height: 120px;
  resize: none;
}

.button_szjSZ {
  background-color: #233f39;
  color: var(--white-background);
  border: none;
  border-radius: 30px;
  min-height: 53px;
  height: 53px;
  font-size: 17px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  -webkit-transition: background-color 0.3s ease;
  -moz-transition: background-color 0.3s ease;
  -ms-transition: background-color 0.3s ease;
  -o-transition: background-color 0.3s ease;
  -webkit-border-radius: 30px;
  -moz-border-radius: 30px;
  -ms-border-radius: 30px;
  -o-border-radius: 30px;
  margin-top: 30px;
}

.buttonForm__pUMn {
  width: 100%;
  height: 48px;
  min-height: 48px;
  padding: 4px 35px;
}

.wsBtn_bBYtT {
  background-color: var(--white-background);
  border: 1px solid #dcdcdc;
  margin-top: 40px;
  width: 55%;
  color: #676767;
  font-weight: 500;
  p {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }
  &:hover {
    background-color: var(--fa-background);
  }
}

.infoContact_IUAUj,
.infoText_edWHr.infoText_edWHr a {
  color: var(--_71717a-color);
}

.keepInformed_LRol1 {
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--_71717a-color);
  input[type="checkbox"] {
    width: 20px;
    height: 20px;
    accent-color: #233f39; 
  }
}

.separator_PBQDE {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
  width: 80%;
}

.line_vUcix {
  flex: 1 1;
  height: 2px;
  background-color: #11a38125;
  margin: 0 10px;
}

.circle_WI13q {
  width: 20px;
  height: 20px;
  color: #e1e1e1;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.rightSection_LAYmN {
  flex: 1 1;
  display: flex;
}



@media (max-width: 860px) {
  .content_hRXhK {
    width: 99%;
  }

  .leftSection_DvE3T {
    width: 100%;
    display: flex;
    justify-content: center;
    form {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 93%;
      .inputGroup_KkTOE {
        width: 100%;
      }
    }
  }

  .rightSection_LAYmN {
    display: none;
  }
}

@media (max-width: 860px) {
  .button_szjSZ {
    font-size: 15px;
  }
}

@media (max-width: 360px) {
  .wsBtn_bBYtT {
    width: 100%;
  }
}
.header_Of7wE {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 85%;
}


.textContainer_tY5EY {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.title_aqF6L {
  margin: 0;
}

.subtitle_JcRep {
  margin: 0;
}

.statusMessage_oUQGf {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  padding: 10px 20px;
  border-radius: 5px;
  font-size: 16px;
  color: var(--white-background);
  opacity: 0;
  animation: fadeInOut_owAS3 3s forwards;
  z-index: 1000;
  -webkit-animation: fadeInOut_owAS3 3s forwards;
  -webkit-animation: fadeInOut_owAS3 3s forwards;
}

.success_AP6kp {
  background-color: var(--f5-background);
  color: black;
  width: 40%;
  > div {
    padding: 10px;
  }
  p {
    margin: 0;
    background-color: var(--white-color);
    color: #38343d;
    padding: 20px;
    width: 100%;
    text-align: start;
    box-sizing: border-box;
    border: 1px solid var(--ececf1-border);
    border-radius: 10px;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    -ms-border-radius: 10px;
    -o-border-radius: 10px;
  }
}

.error_MHx_h {
  background-color: #f44336;
}

@keyframes fadeInOut_owAS3 {
  0% {
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.startNowSection_81o1t {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 0;
  padding: 0 10px;
}
.reviewsTitle_Jh642 {
    font-size: clamp(20px, 5vw, 50px) !important; 
  font-weight: 400;
  color: #18181b;
  text-align: center;
  margin-bottom: 10px;
}

.reviewsDescriptionLast_qrCt7 {
  font-size: clamp(
    12px,
    1.5vw,
    27px
  ) !important; 
  font-weight: 400;
  max-width: 720px;
  margin-top: 5px;
  margin-bottom: 10px;
  color: #676767;
  text-align: center;
}
.startsFrom_V55eP {
  font-weight: 700;
  font-size: 36px;
  color: var(--_10a37f-background);
  display: flex;

  gap: 10px;
  span {
    color: black;
  }
  span:first-child {
    font-weight: 300;
  }
}
.price_xVJ9L {
    font-size: clamp(30px, 12vw, 86px) !important; 
  color: #18181b;
  font-weight: 700;
  margin-bottom: 20px;
  span {
    margin-left: -10px;
    font-size: 46px;
  }
}

.startButton_jJ1fz {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  color: var(--white-background);
  font-size: 18px;
  font-weight: 400;
  background: var(--_10a37f-background);
  width: 100%;
  max-width: 360px;
  height: 57px;
  min-height: 57px;
  text-decoration: none;
  gap: 15px;
  -webkit-border-radius: 999px;
  -moz-border-radius: 999px;
  -ms-border-radius: 999px;
  -o-border-radius: 999px;
  img {
    height: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/ContactForm/ContactForm.module.css"],"names":[],"mappings":"AACA;;EAEE,2FAA2F;AAC7F;AACA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,WAAW;;EAEX,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX;;IAEE,WAAW;EACb;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,4CAA4C;EAC5C,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,4CAA4C;EAC5C,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,SAAO;AACT;AACA;EACE,aAAa;EACb,WAAW;EACX,SAAS;AACX;AACA;EACE;IACE,sBAAsB;IACtB,QAAQ;EACV;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,sCAAsC;EACtC,2BAA2B;EAC3B,sBAAsB;EACtB;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,8CAA8C;EAC9C,2CAA2C;EAC3C,0CAA0C;EAC1C,yCAAyC;EACzC,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC,yBAAyB;EACzB,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;EACX;EACA;IACE,sCAAsC;EACxC;AACF;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2BAA2B;EAC3B;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;EACvB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,WAAW;EACX,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;AACf;;;;AAIA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB;MACE,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,UAAU;MACV;QACE,WAAW;MACb;IACF;EACF;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;;AAGA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,8BAA8B;EAC9B,UAAU;EACV,sCAAgC;EAChC,aAAa;EACb,8CAAwC;EACxC,8CAAwC;AAC1C;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,UAAU;EACV;IACE,aAAa;EACf;EACA;IACE,SAAS;IACT,oCAAoC;IACpC,cAAc;IACd,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,sCAAsC;IACtC,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;EACxB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;AACA;IACI,4CAA4C;EAC9C,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;;;;cAIY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,aAAa;;EAEb,SAAS;EACT;IACE,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;AACF;AACA;IACI,6CAA6C;EAC/C,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;EACT,4BAA4B;EAC5B,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB;IACE,YAAY;EACd;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap\");\n.container {\n \n  background: linear-gradient(180deg, var(--white-background) 21%, var(--f5-background) 100%);\n}\n.containerInner{\n  display: flex !important;\n  font-family: \"Inter\", sans-serif;\n  justify-content: space-between;\n  align-items: center;\n  flex-direction: column;\n  gap: 2rem;\n  width: 100%;\n \n  margin-top: 80px;\n  background-color: transparent;\n}\n.content {\n  display: flex;\n  width: 63%;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  input,\n  textarea {\n    width: 100%;\n  }\n}\n\n.leftSection {\n  width: 100%;\n}\n\n.title {\n  font-size: clamp(35px, 5vw, 55px) !important; \n  font-weight: 400;\n  color: #18181b;\n  margin-bottom: 0.5rem;\n}\n\n.subtitle {\n  font-size: clamp(12px, 3vw, 22px) !important; \n  font-weight: 400;\n  color: #676767;\n  margin-bottom: 2rem;\n}\n\n.inputGroup {\n  margin-bottom: 1rem;\n  width: 100%;\n  flex: 1;\n}\n.inputGroupContainer {\n  display: flex;\n  width: 100%;\n  gap: 30px;\n}\n@media (max-width: 468px) {\n  .inputGroupContainer {\n    flex-direction: column;\n    gap: 2px;\n  }\n}\n\nlabel {\n  display: block;\n  font-size: 14px;\n  color: #18181b;\n  margin-bottom: 0.5rem;\n}\n\n.input,\n.textarea {\n  width: 100%;\n  min-width: 200px;\n  outline: none;\n  border: 1px solid var(--f4-background);\n  border-radius: 8px;\n  font-size: 14px;\n  padding: 1rem;\n  background-color: var(--f4-background);\n  color: var(--_71717a-color);\n  box-sizing: border-box;\n  &:focus {\n    border: 2px solid #dadbdd;\n  }\n}\n\n.input {\n  height: fit-content;\n}\n\n.textarea {\n  height: 120px;\n  resize: none;\n}\n\n.button {\n  background-color: #233f39;\n  color: var(--white-background);\n  border: none;\n  border-radius: 30px;\n  min-height: 53px;\n  height: 53px;\n  font-size: 17px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 15px;\n  -webkit-transition: background-color 0.3s ease;\n  -moz-transition: background-color 0.3s ease;\n  -ms-transition: background-color 0.3s ease;\n  -o-transition: background-color 0.3s ease;\n  -webkit-border-radius: 30px;\n  -moz-border-radius: 30px;\n  -ms-border-radius: 30px;\n  -o-border-radius: 30px;\n  margin-top: 30px;\n}\n\n.buttonForm {\n  width: 100%;\n  height: 48px;\n  min-height: 48px;\n  padding: 4px 35px;\n}\n\n.wsBtn {\n  background-color: var(--white-background);\n  border: 1px solid #dcdcdc;\n  margin-top: 40px;\n  width: 55%;\n  color: #676767;\n  font-weight: 500;\n  p {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n  }\n  &:hover {\n    background-color: var(--fa-background);\n  }\n}\n\n.infoContact,\n.infoText.infoText a {\n  color: var(--_71717a-color);\n}\n\n.keepInformed {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: var(--_71717a-color);\n  input[type=\"checkbox\"] {\n    width: 20px;\n    height: 20px;\n    accent-color: #233f39; \n  }\n}\n\n.separator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 20px 0;\n  width: 80%;\n}\n\n.line {\n  flex: 1;\n  height: 2px;\n  background-color: #11a38125;\n  margin: 0 10px;\n}\n\n.circle {\n  width: 20px;\n  height: 20px;\n  color: #e1e1e1;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.rightSection {\n  flex: 1;\n  display: flex;\n}\n\n\n\n@media (max-width: 860px) {\n  .content {\n    width: 99%;\n  }\n\n  .leftSection {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    form {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      width: 93%;\n      .inputGroup {\n        width: 100%;\n      }\n    }\n  }\n\n  .rightSection {\n    display: none;\n  }\n}\n\n@media (max-width: 860px) {\n  .button {\n    font-size: 15px;\n  }\n}\n\n@media (max-width: 360px) {\n  .wsBtn {\n    width: 100%;\n  }\n}\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 85%;\n}\n\n\n.textContainer {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.title {\n  margin: 0;\n}\n\n.subtitle {\n  margin: 0;\n}\n\n.statusMessage {\n  position: fixed;\n  top: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 10px 20px;\n  border-radius: 5px;\n  font-size: 16px;\n  color: var(--white-background);\n  opacity: 0;\n  animation: fadeInOut 3s forwards;\n  z-index: 1000;\n  -webkit-animation: fadeInOut 3s forwards;\n  -webkit-animation: fadeInOut 3s forwards;\n}\n\n.success {\n  background-color: var(--f5-background);\n  color: black;\n  width: 40%;\n  > div {\n    padding: 10px;\n  }\n  p {\n    margin: 0;\n    background-color: var(--white-color);\n    color: #38343d;\n    padding: 20px;\n    width: 100%;\n    text-align: start;\n    box-sizing: border-box;\n    border: 1px solid var(--ececf1-border);\n    border-radius: 10px;\n    -webkit-border-radius: 10px;\n    -moz-border-radius: 10px;\n    -ms-border-radius: 10px;\n    -o-border-radius: 10px;\n  }\n}\n\n.error {\n  background-color: #f44336;\n}\n\n@keyframes fadeInOut {\n  0% {\n    opacity: 0;\n  }\n  10% {\n    opacity: 1;\n  }\n  90% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n.startNowSection {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-top: 0;\n  padding: 0 10px;\n}\n.reviewsTitle {\n    font-size: clamp(20px, 5vw, 50px) !important; \n  font-weight: 400;\n  color: #18181b;\n  text-align: center;\n  margin-bottom: 10px;\n}\n\n.reviewsDescriptionLast {\n  font-size: clamp(\n    12px,\n    1.5vw,\n    27px\n  ) !important; \n  font-weight: 400;\n  max-width: 720px;\n  margin-top: 5px;\n  margin-bottom: 10px;\n  color: #676767;\n  text-align: center;\n}\n.startsFrom {\n  font-weight: 700;\n  font-size: 36px;\n  color: var(--_10a37f-background);\n  display: flex;\n\n  gap: 10px;\n  span {\n    color: black;\n  }\n  span:first-child {\n    font-weight: 300;\n  }\n}\n.price {\n    font-size: clamp(30px, 12vw, 86px) !important; \n  color: #18181b;\n  font-weight: 700;\n  margin-bottom: 20px;\n  span {\n    margin-left: -10px;\n    font-size: 46px;\n  }\n}\n\n.startButton {\n  margin-top: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 999px;\n  color: var(--white-background);\n  font-size: 18px;\n  font-weight: 400;\n  background: var(--_10a37f-background);\n  width: 100%;\n  max-width: 360px;\n  height: 57px;\n  min-height: 57px;\n  text-decoration: none;\n  gap: 15px;\n  -webkit-border-radius: 999px;\n  -moz-border-radius: 999px;\n  -ms-border-radius: 999px;\n  -o-border-radius: 999px;\n  img {\n    height: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_g2JT7`,
	"containerInner": `containerInner_vmXtV`,
	"content": `content_hRXhK`,
	"form": `form_dNAyi`,
	"leftSection": `leftSection_DvE3T`,
	"title": `title_aqF6L`,
	"subtitle": `subtitle_JcRep`,
	"inputGroup": `inputGroup_KkTOE`,
	"inputGroupContainer": `inputGroupContainer_niid7`,
	"input": `input_mAlnQ`,
	"textarea": `textarea_BI7BM`,
	"button": `button_szjSZ`,
	"buttonForm": `buttonForm__pUMn`,
	"wsBtn": `wsBtn_bBYtT`,
	"infoContact": `infoContact_IUAUj`,
	"infoText": `infoText_edWHr`,
	"keepInformed": `keepInformed_LRol1`,
	"separator": `separator_PBQDE`,
	"line": `line_vUcix`,
	"circle": `circle_WI13q`,
	"rightSection": `rightSection_LAYmN`,
	"header": `header_Of7wE`,
	"textContainer": `textContainer_tY5EY`,
	"statusMessage": `statusMessage_oUQGf`,
	"fadeInOut": `fadeInOut_owAS3`,
	"success": `success_AP6kp`,
	"error": `error_MHx_h`,
	"startNowSection": `startNowSection_81o1t`,
	"reviewsTitle": `reviewsTitle_Jh642`,
	"reviewsDescriptionLast": `reviewsDescriptionLast_qrCt7`,
	"startsFrom": `startsFrom_V55eP`,
	"price": `price_xVJ9L`,
	"startButton": `startButton_jJ1fz`
};
export default ___CSS_LOADER_EXPORT___;
